import { mapActions, mapGetters } from "vuex"

export default {
  computed: {
    ...mapGetters(['getAllGame']),
    gameSeries () {
      let gameseries = [];
      let series = [
        {
          id: 0,
          value: '全部'
        },
        {
          id: 1,
          value: '六合彩系列'
        },
        {
          id: 2,
          value: 'PK拾系列'
        },
        {
          id: 3,
          value: '時時彩系列'
        },
        {
          id: 4,
          value: '快十系列'
        },
        {
          id: 5,
          value: '快三系列'
        },
        {
          id: 6,
          value: '11选5系列'
        },
        {
          id: 7,
          value: '基诺彩系列'
        },
        {
          id: 8,
          value: '福利彩系列'
        },
        {
          id: 9,
          value: '28系列'
        },
        {
          id: 10,
          value: '体育彩系列'
        },
        {
          id: 11,
          value: '官方彩系列'
        }
      ]
      // let arr = Array.from(new Set(this.getAllGame.filter(it => it.ismy).map(it => it.catenaId)))
      // let nogame = []
      // series.forEach((it, idx) => {
      //   if (arr.indexOf(it.id) == -1) nogame.push(it)
      // })
      // series.forEach(it => {
      //   nogame.forEach(nit => {
      //     if (it.id != nit.id) gameseries.push(it)
      //   })
      // })
      // gameseries.unshift(
      //   {
      //     id: 0,
      //     value: '全部'
      //   })
      return series
    }
  }
}